import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import type { GridColDef } from '@mui/x-data-grid-premium';
import React from 'react';
import { useSharedGridStyles } from './utils';

const SplitIcon = ({
  cellId,
}: {
  cellId: string;
}) => {
  const { classes } = useSharedGridStyles();

  return (
    <Tooltip title='Split'>
      <Box id={cellId} data-testid={cellId} width={20}>
        <CallSplitOutlinedIcon className={classes.icon} />
      </Box>
    </Tooltip>
  );
};

export const getSplitColumn = (): GridColDef => ({
  field: 'split',
  headerName: 'Split',
  description: 'Split',
  renderHeader: () => <SplitIcon cellId='split-header' />,
  type: 'boolean',
  disableColumnMenu: true,
  width: 20,
  minWidth: 0,
  groupable: false,
  aggregable: false,
  renderCell: (params) =>
    params.value ? (
      <SplitIcon cellId={`${params.row.month}-split-${params.value}-${params.row.transactionId}`} />
    ) : null,
});
